// src/PacienteContext.js
import React, { createContext, useState, useContext } from 'react';

const PacienteContext = createContext();

const PacienteProvider = ({ children }) => {
  const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
  // NOVO: Estado para controlar o bloqueio da tela durante operações críticas
  const [isScreenLocked, setIsScreenLocked] = useState(false);

  const [fotoAntesProntuario, setFotoAntesProntuario] = useState(null); // Novo estado para a foto "Antes"
  const [fotoDepoisProntuario, setFotoDepoisProntuario] = useState(null); // Novo estado para a foto "Depois"

  // Estados para o controle de salvamento da consulta
  const [saveConsultaTrigger, setSaveConsultaTrigger] = useState(0);
  const [isSavingConsultaContext, setIsSavingConsultaContext] = useState(false);
  const [saveResultMessageContext, setSaveResultMessageContext] = useState(null); // { type: 'success'/'danger', text: 'mensagem' }

  // Função para acionar o salvamento da consulta
  const triggerSaveConsultaFunction = () => {
    setSaveConsultaTrigger(prev => prev + 1); // Incrementa o contador para disparar o useEffect no Prontuario.js
  };

  const [isConsultaSalva, setIsConsultaSalva] = useState(true); // Novo estado: true se salva, false se modificada
  const [activeProntuarioTabKeyContext, setActiveProntuarioTabKeyContext] = useState('identificacao'); // Estado para aba ativa do Prontuario.js
  const [lastActivePatientContext, setLastActivePatientContext] = useState(null); // Estado para o último paciente ativo

  // NOVO: Gatilho para forçar a atualização dos dados do agendamento
  const [refreshAppointmentsTrigger, setRefreshAppointmentsTrigger] = useState(0);

  return (
<PacienteContext.Provider value={{ 
      pacienteSelecionado, setPacienteSelecionado, 
      isScreenLocked, // Exporta o estado de bloqueio
      setIsScreenLocked, // Exporta a função para alterar o estado de bloqueio
      fotoAntesProntuario, setFotoAntesProntuario, 
      fotoDepoisProntuario, setFotoDepoisProntuario,
      saveConsultaTrigger, triggerSaveConsultaFunction,
      isSavingConsultaContext, setIsSavingConsultaContext,
      saveResultMessageContext, setSaveResultMessageContext,
      isConsultaSalva, setIsConsultaSalva,
      activeProntuarioTabKeyContext, setActiveProntuarioTabKeyContext,
      lastActivePatientContext, setLastActivePatientContext, // Adiciona ao provider
      triggerRefreshAppointments: () => setRefreshAppointmentsTrigger(c => c + 1) // Função para acionar o gatilho
    }}>
      {children}
    </PacienteContext.Provider>
  );
};

const usePacienteContext = () => {
  return useContext(PacienteContext);
};

export { PacienteContext, PacienteProvider, usePacienteContext };
